import React from "react";

function Info() {
  return (
    <div className="container">
      <div className="row" style={{ textAlign: "justify" }}>
        <div className="border-bottom">
          <h1 className="fs-2" style={{ color: "#000088" }}>
            Vision
          </h1>
          <p>
            Our vision is to become our clients' preferred and trusted partner
            by providing them result-oriented, innovative and exceptional
            services. We want to be recognised as an organisation that delivers
            the highest level of service, knowledge, professionalism, honesty
            and integrity.
          </p>
          <p>
            We strive to be the leading technology professional services and
            recruitment agency and want to be the leading supplier of niche
            technology talent to businesses and create value for them.
          </p>
        </div>
        <div className="mt-3 border-bottom">
          <h1 className="fs-2" style={{ color: "#000080" }}>
            Mission
          </h1>
          <p>
            We are a professional, passionate and innovative team on a mission
            to propel our client's businesses to new levels of success and help
            them become more productive and profitable. Our objective is to
            deliver tangible and sustainable results for clients through
            innovative and forward-thinking.
          </p>
        </div>
        <div className="mt-3">
          <h1 className="fs-2" style={{ color: "#000080" }}>
            Values
          </h1>
          <p>
            Our core values shape our vision, culture and reflect in what we do.
            Our values are embedded in everything we do.
          </p>
        </div>
        <div className="mt-2">
          <h1 className="fs-5" style={{ color: "#000080" }}>
            Trust & Partnership
          </h1>
          <p>
            We are a trusted partner of our clients and candidates. Trust and
            partnership are at the foundation of everything we do, and we strive
            to create a win-win situation for all our stakeholders.
          </p>
        </div>
        <div className="mt-2">
          <h1 className="fs-5" style={{ color: "#000080" }}>
            Honesty & Integrity
          </h1>
          <p>
            We are committed to conducting business to promote fairness,
            transparency, honesty, integrity and trust.
          </p>
        </div>
        <div className="mt-2">
          <h1 className="fs-5" style={{ color: "#000080" }}>
            Commitment
          </h1>
          <p>
            We are committed to make positive contributions to our client's
            business and deliver exceptional results by providing end-to-end
            solutions. But, above all, we honour all our commitments.
          </p>
        </div>
        <div className="mt-2">
          <h1 className="fs-5" style={{ color: "#000080" }}>
            Professionalism
          </h1>
          <p>
            We are highly professional and strive for excellence and quality in
            everything we do.
          </p>
        </div>
        <div className="mt-2">
          <h1 className="fs-5" style={{ color: "#000080" }}>
            Innovation
          </h1>
          <p>
            We aim to create value for our clients by delivering innovative
            solutions that drive their business forward.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Info;
